import { createFileRoute } from "@tanstack/react-router"

import { BuiltPalletsTab } from "@/screens/WarehouseReceiving/subfeatures/CheckedIn/components/BuiltPalletsTab"

export const Route = createFileRoute(
  "/app/tablet/warehouse-receiving/checked-in/$goodsReceiptId/_layout/built-pallets"
)({
  component: BuiltPalletsTab,
})
